import React from 'react'
import { DatePicker, DateRangePicker, InputGroup } from 'rsuite'
import { t } from '../../../utils/i18n'
import { InfoTooltip } from '../../atoms/info-tooltip/info-tooltip'
import CustomDropdown, { DropdownOption } from '../../molecules/dropdown/dropdown'
import './asset-date-filter.scss'
import { CanBeAnything } from '../../../types'
import subDays from 'date-fns/subDays'
import { useEffect, useState } from 'react'
const { allowedRange } = DateRangePicker

const predefinedRanges: DropdownOption[] = [
  {
    name: 'Last 30 days',
    value: [subDays(new Date(), 29), new Date()],
    id: '1',
  },
  {
    name: 'Last 60 days',
    value: [subDays(new Date(), 59), new Date()],
    id: '2',
  },
  {
    name: 'Last 90 days',
    value: [subDays(new Date(), 89), new Date()],
    id: '3',
  },
  {
    name: 'Custom',
    value: 'custom',
    id: '4',
  },
]

interface AssetDateFilterProps {
  getDateRange?: (s: string, e: string) => void
}

export const AssetDateFilter = ({ getDateRange }: AssetDateFilterProps) => {
  const [freq, setFreq] = useState<DropdownOption>()
  const [endDateDisable, setEndDateDisable] = useState(true)
  const [startDate, setStartDate] = useState<Date | null>()
  const [endDate, setEndDate] = useState<Date | null>()
  const [startDateDisable] = useState(false)

  useEffect(() => {
    handleSelectDate(predefinedRanges[0])
  }, [])

  const updateDateFormatApi = (val: CanBeAnything) => {
    const d = new Date(val)
    d.setUTCHours(0, 0, 0, 0)
    const yyyy = d.getFullYear()
    let mm: number | string = d.getMonth() + 1
    let dd: number | string = d.getDate()

    if (dd < 10) dd = '0' + dd
    if (mm < 10) mm = '0' + mm

    return yyyy + '-' + mm + '-' + dd
  }

  const handleDateRange = (date: CanBeAnything) => {
    setStartDate(new Date(date[0]))
    setEndDate(new Date(date[1]))
    const startDate = updateDateFormatApi(date[0])
    const endDate = updateDateFormatApi(date[1])
    getDateRange?.(startDate, endDate)
  }

  const handleSelectDate = (freqency: CanBeAnything) => {
    setFreq(freqency)
    if (freqency.value !== 'custom') {
      setEndDateDisable(false)
      handleDateRange(freqency.value)
    } else {
      setEndDateDisable(true)
      setStartDate(null)
      setEndDate(null)
    }
  }

  const onStartDateChange = (val: CanBeAnything) => {
    if (val && val !== null) {
      setFreq(predefinedRanges[3])
      setStartDate(new Date(val))
      setEndDateDisable(false)
      setEndDate(null)
    } else {
      setFreq(freq)
      setStartDate(val)
      setEndDate(null)
      setEndDateDisable(true)
    }
  }

  const onEndDateChange = (val: CanBeAnything) => {
    if (val && val !== null) {
      setFreq(predefinedRanges[3])
      setEndDate(new Date(val))
      handleDateRange([new Date(startDate as Date), new Date(val)])
    } else {
      setFreq(freq)
      setEndDate(val)
    }
  }

  return (
    <div className="date-filter-container">
      <div className="dropdown-wrapper">
        <div className="title-info">
          <p className="label-input">
            {t('selectFrequency')} <strong>*</strong>
          </p>
          <InfoTooltip
            styleClass="input-info"
            tooltipContent={t('businessName.dropdown.tooltip')}
            placement={'right'}
          />
        </div>
        <div className="dropdown">
          <CustomDropdown
            label=""
            options={predefinedRanges}
            onSelect={handleSelectDate}
            id="asset-date-range"
            defaultSelectedId={freq && freq.id}
          />
        </div>
      </div>
      <div className="date-picker">
        <div className="bottom-section date_picker_width">
          <InputGroup>
            <DatePicker
              id="start-date"
              disabled={startDateDisable}
              format="dd-MM-yyyy"
              value={startDate}
              onChange={onStartDateChange}
              shouldDisableDate={allowedRange(new Date('04-01-2022') as Date, new Date())}
              placeholder={t('report.wrapper.start.date')}
              oneTap
            />
            <InputGroup.Addon>-</InputGroup.Addon>
            <DatePicker
              id="end-date"
              disabled={endDateDisable}
              format={'dd-MM-yyyy'}
              value={endDate}
              onChange={onEndDateChange}
              shouldDisableDate={allowedRange(startDate as Date, new Date())}
              placeholder={t('report.wrapper.end.date')}
              oneTap
            />
          </InputGroup>
        </div>
      </div>
    </div>
  )
}
